import { gql } from '@apollo/client';
import { GqlTemplateResponseTypes } from 'modules/templateEditor/common';
import { useRumError } from 'services/observability/datadog';
import { useGraphql } from 'utils/hooks/useGraphql';
import { Nullable } from 'utils/tsHelpers';

const source = 'useMessageTypeIdQuery';

export const fetchTemplateMessageTypeIdQuery = gql`
  query fetchTemplateMessageTypeId($templateId: Long!, $locale: TemplateLocaleInput) {
    templateAndSingleContent(id: $templateId, locale: $locale) {
      __typename
      ... on TemplateAndContent {
        messageType {
          id
        }
      }
    }
  }
`;

export const useMessageTypeIdQuery = () => {
  const addErrorSignal = useRumError();
  const {
    error,
    errorMessage,
    refetch: fetchTemplateMessageTypeId,
  } = useGraphql(fetchTemplateMessageTypeIdQuery, {
    skip: true,
  });

  if (error && errorMessage) {
    addErrorSignal(errorMessage, source);
  }

  return async (templateId: number, locale: Nullable<string>) => {
    try {
      const {
        data: { templateAndSingleContent, __typename },
        error: hasError,
      } = await fetchTemplateMessageTypeId({
        templateId,
        locale: locale
          ? {
              name: locale,
            }
          : null,
      });

      const hasValidId =
        !hasError &&
        ![
          GqlTemplateResponseTypes.CORRUPTED_TEMPLATE_DATA,
          GqlTemplateResponseTypes.NO_TEMPLATE_FOUND,
        ].includes(__typename);

      return hasValidId ? templateAndSingleContent.messageType.id : -1;
    } catch (e) {
      const err = e instanceof Error ? e.message : `${e}`;
      addErrorSignal(new Error(err), source);
    }
    return null;
  };
};
